import { useBootstrap } from './BootstrapContext';
import type { PageSeo } from './pageSeoApi';

// The actual fetch/provider now lives in BootstrapContext.tsx (combined
// with media + site settings into a single request). This wrapper stays so
// existing call sites (usePageSeoContext) don't need to change.
export function usePageSeoContext(): { pages: Record<string, PageSeo>; siteSettings: Record<string, string> } {
  const { pageSeo, siteSettings } = useBootstrap();
  return { pages: pageSeo, siteSettings };
}
